var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#FEE119"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 6.5,
    fill: "#F5BE00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7051 6.99023L11.418 8.02734H5.93359L6.2207 6.99023H11.7051ZM9.05078 13.4062L6.10352 9.93164L6.09766 9.05859H7.49805C7.86133 9.05859 8.16016 8.99414 8.39453 8.86523C8.63281 8.73242 8.81055 8.55469 8.92773 8.33203C9.04492 8.10547 9.10352 7.85352 9.10352 7.57617C9.10352 7.27539 9.04883 7.00977 8.93945 6.7793C8.83008 6.54883 8.65625 6.36914 8.41797 6.24023C8.17969 6.11133 7.86523 6.04688 7.47461 6.04688H5.93945L6.25586 4.875H7.47461C8.16602 4.875 8.74023 4.97852 9.19727 5.18555C9.6543 5.39258 9.99609 5.69336 10.2227 6.08789C10.4531 6.48242 10.5684 6.95898 10.5684 7.51758C10.5684 8.00586 10.4844 8.4375 10.3164 8.8125C10.1484 9.18359 9.87695 9.48438 9.50195 9.71484C9.12695 9.94141 8.62891 10.082 8.00781 10.1367L10.7031 13.3301V13.4062H9.05078ZM11.7109 4.875L11.418 5.91211H6.93555L7.22266 4.875H11.7109Z",
    fill: "#FEE119"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.dd756707662906cbf9e5b80b2bd71010.svg";
export { ForwardRef as ReactComponent };